
export default function IncludedPhotoGalleryImageNormalizedData(
  serializedImage,
  deserializedImage,
  drupalIncluded,
) {

  const imageId = deserializedImage?.id;
  const includedImageData = drupalIncluded.find(
    ( include ) => include.id === imageId,
  );

  const image = {
    id: imageId,
    image: {
      modal: includedImageData?.links?.modal?.href,
    },
    caption: serializedImage?.meta?.alt,
  };

  return image;
}